import { render, staticRenderFns } from "./WaitingRoomModule.vue?vue&type=template&id=c87e3f76&"
import script from "./WaitingRoomModule.vue?vue&type=script&lang=js&"
export * from "./WaitingRoomModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports